import axios from "axios"; //used for req to backend
import React, {useEffect, useState} from "react";
import { useParams } from "react-router-dom"; //used for getting values from URL
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import "../../style/rsvpEventStyle.css";
import ErrorMessage from "../Misc/ErrorMessage"; //used for displaying error msg from backend
import SuccMessage from "../Misc/succMessage";
import Spinner from 'react-bootstrap/Spinner'; //spinner animation when req are being handeld
import TestGround from '../Misc/testGround';
/**
 * pages that renders when invited user chooses to rsvp to an event
 * can send message to event owner as well if they choose
 * pre populates fileds using url params
 * url params = contactID and eventID
 */
function RsvpEvent() {
    const [setEventId] = useState("");
    const [userMessage, setUserMessage] = useState("");
    const [spotsLeft, setSpotsLeft] = useState("");
    const [disable, setDisable] = useState(false);
    const [title, setTitle] = useState("");
    const [succMessage, setSuccMessage] = useState(null);
    const [ errorMessage, setErrorMessage] = useState(null);
    const [vaxlotNumber, setVaxLotNumber] = useState(""); //Vaccien lot number
    const [vaxProvider, setVaxProvider] = useState(""); //will be used in vaccine company dropdown
    const [vaxErrorMessage, setVaxErrorMessage] = useState(null);
    const [spinnerShow, setSpinnerShow] = useState(true);
    const [moJj, setMoJj] = useState(true);
    const [pfOt, setPfOt] = useState(true);
    const [vaxed, setVaxed] = useState("");
    const [unLock, setUnLock] = useState(true);
    const [vaxCheckUnlock, setVaxCheckUnlock] = useState(true);
    const [hasRsvped, setHasRsvped] = useState(false);
    const [invited, setInvited] = useState("");
    const [showMessage, setShowMessage] = useState(true);

    

    const {id} = useParams();
    const {cid} = useParams();
    //decides which vaccine provider is choosen then selects renders
    const onChangeVaxPro = e => {
        if(e.target.value === "moderna" || e.target.value === "johnson") {
            setMoJj(false);
            setPfOt(true);
            setVaxProvider(e.target.value);
        } else if (e.target.value === "pfizer" || e.target.value === "other") {
            setVaxProvider(e.target.value);
            setMoJj(true);
            setPfOt(false);
        } else {
            setVaxProvider(e.target.value);
            setMoJj(true);
            setPfOt(true);
        }
    }

    const onChangeVaxQue = e => {
        if(e.target.value === "yes") {
            setVaxed("yes");
        } else {
            setVaxed("no");
        }
    }

    async function checkInvite() {
        const inviteCheck = {
            contactId: cid,
            eventId: id
        }

        try {
            const invited = await axios.post("https://link2rsvp.herokuapp.com/contact/stillInvited", inviteCheck);
            if(invited.data === "true") {
                setInvited(false);
                return;
            } else {
                setInvited(true);
                setVaxCheckUnlock(true);
                setUnLock(true);
            }
        } catch (err) {
            if (err.response) {
                if (err.response.data.errorMessage){
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }
    }

    /**
     * functoin checkRsvp()
     * checks if a user has already rsvped to an event
     */
    async function checkRsvp() {
    
        const rsvpCheck = {
            contactId:  cid,
            eventId: id
        }
       
        const rsvped = await axios.post("https://link2rsvp.herokuapp.com/contact/rsvped", rsvpCheck);
        
        if (rsvped.data === "true") {
            setHasRsvped(true);
            setShowMessage(false);
        }
        else 
            setHasRsvped(false);
    }
    /**
     * function getEventName()
     * gets the rsvp event name for displaying
     */
    async function getEventName() {
        try {
            const eventRes = await axios.get(`https://link2rsvp.herokuapp.com/event/eventdetails/${id}`);
            setTitle(eventRes.data.title);
        } catch (err) {
            console.log(err.response);
        }
    }
    /**
     * function checkIfNeedVax()
     * checks if certain event needs required vaccines or not
     */
    async function checkIfNeedVax() {
        const vaxReq = await axios.get(`https://link2rsvp.herokuapp.com/event/vax/${id}`);
        if(vaxReq.data === "true") {
            setVaxCheckUnlock(false);
            setUnLock(true);
        } else if (vaxReq.data === "false") {
            setVaxCheckUnlock(true);
            setUnLock(false);
        } else {
            setVaxCheckUnlock(false);
            setUnLock(false);
        }
    }
    /**
     * function getSpotsLeft()
     * gets the number of spots left to rsvp to an event
     */
    async function getSpotsLeft() {
        try {
            const spots = await axios.get(`https://link2rsvp.herokuapp.com/event/${id}/spots`);
            setSpotsLeft(spots.data);
            if(spots.data === 0) {
                setDisable(true);
            }
        } catch (err) {
            if (err.response) {
                if (err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }
    }
    /**
     * function addNumber()
     * Adds a contact to the rsvp list of an event
     */
    async function addNumber(e) {
        e.preventDefault();
        let today = new Date();
        let hour = today.getHours();
        if(hour < 10) {
            hour = '0'+hour;
        }
        let minutes = today.getMinutes();
        if(minutes < 10){
            minutes = '0'+minutes;
        }
        const timeCurrent = hour+':'+minutes;
        const messageData = {
            message: userMessage
        };
        const mesgData = {
            eventid: id,
            contactid: cid,
            message: userMessage,
            time: timeCurrent
        };
        try {
            await axios.put(`https://link2rsvp.herokuapp.com/event/${id}/${cid}/attendnumber`, messageData);
            await axios.post("https://link2rsvp.herokuapp.com/event/message", mesgData);
            setSuccMessage("you have RSVPed");
            setShowMessage(false);
            window.location.reload();
        } catch (err) {
            if (err.response) {
                if(err.response.data.errorMessage) {
                    setErrorMessage(err.response.data.errorMessage);
                }
            }
        }
        getSpotsLeft();
    }
//checks vaccine status and legit vaccine lot number for J&J and Moderna
    async function vaxCheck(e) {
        e.preventDefault();

        if (vaxProvider === "moderna" || vaxProvider === "johnson") {
            setSpinnerShow(false);
            const vaxData = {
                lotNum: vaxlotNumber,
                lotProvider: vaxProvider
            };
            try {
                const response = await axios.post("https://link2rsvp.herokuapp.com/vaxloopup/", vaxData);
                setVaxLotNumber("");
                setVaxProvider("");
                setUnLock(false);
                setDisable(false);
                setVaxCheckUnlock(true);
                console.log(response.data.SuccMessage);
                setSuccMessage(response.data.SuccMessage);
            } catch (err) {
                if (err.response) {
                    if(err.response.data.errorMessage) {
                        setVaxErrorMessage(err.response.data.errorMessage);
                    }
                }
            }
            setSpinnerShow(true);
        } else if (vaxProvider === "pfizer" || vaxProvider ==="other") {
            console.log(vaxed);
            if (vaxed === "no") {
                alert("You must be Vaccinated to attend this event");
            } else {
                setUnLock(false);
                setDisable(false);
                setVaxCheckUnlock(true);
            }

        } else if (vaxProvider === "none") {
            alert("You must be Vaccinated to attend this event");
        }
    }

    useEffect(() => {
        getSpotsLeft();
        checkIfNeedVax();
        checkRsvp();
        getEventName();
        checkInvite();
        //eslint-disable-next-line react-hooks/exhaustive-deps
    },[]);


    return (
    <div>
        <div id="head">
            <h1 id="headp">LINK2RSVP</h1>
        </div>
        {!hasRsvped && disable && (
            <ErrorMessage
            message={"No more spots left to rsvp"}
            />
        )}

        {
            vaxErrorMessage && (
                <ErrorMessage
                message={vaxErrorMessage}
                clear={() => setVaxErrorMessage(null)}
                />
            )
        }

        {
            invited && (
                <ErrorMessage
                message={"You have been uninvited from this event"}
                />
            )
        }
        
        {
            succMessage && (
                <SuccMessage
                message={succMessage}
                clear={() => setSuccMessage(null)}
                />
            )
        }

        {
            errorMessage && (
                <ErrorMessage
                message={errorMessage}
                clear={() => setErrorMessage(null)}
                />
            )
        }

        <div id="rsvp">
            <h3>RSVP to {title}</h3>
            <form onSubmit={vaxCheck} hidden={vaxCheckUnlock || hasRsvped}>
                <p>This event requires covid-19 vaccination</p>
                <Form.Group className="mb=3" id="vaxselector">
                    <label htmlFor="vaxSelector">Choose your vaccine provider:</label>
                    <select
                    name="vaxSelector"
                    id="vaxSelector"
                    value={vaxProvider}
                    onChange={onChangeVaxPro}
                    required
                    >
                        <option value="select">--Select A Provider--</option>
                        <option value="moderna">Moderna</option>
                        <option value="johnson">Johnson and Johnson</option>
                        <option value="pfizer">Pfizer</option>
                        <option value="other">Other</option>
                        <option value="none">Not Vaccinated</option>
                    </select>
                </Form.Group>
                <Form.Group className="mb=3" id="lotNumber" hidden={moJj}>
                    <Form.Label htmlFor="lotNumber">Please enter your vaccine lot Number</Form.Label>
                    <Form.Control
                    name="lotNumber"
                    placeholder="Ex: 052D25Q"
                    type="text"
                    value={vaxlotNumber}
                    onChange={(e) => setVaxLotNumber(e.target.value)}
                    required={!moJj}
                    />
                    <Form.Text className="text-muted">
                         We will check with Moderna and J&J websites to ensure lot number legitmacy.
                    </Form.Text>
                </Form.Group>
                <Form.Group className="mb=3" id="yes/no" hidden={pfOt}>
                   <label htmlFor="yes/no">Have you received a Coivd-19 Vaccine?</label>
                   <select
                   name="yes/no"
                   id="yes/no"
                   value={vaxed}
                   onChange={onChangeVaxQue}
                   >
                       <option value="select">--Select--</option>
                       <option value="yes">Yes</option>
                       <option value="no">No</option>
                   </select>
                </Form.Group>
                <Button style={{backgroundColor: "rgb(138,14,50)"}} id="vax-btn" type="submit" disabled={disable} variant="secondary">Submit</Button>
                <Spinner animation="border" role="status" hidden={spinnerShow}>
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </form>
            <form onSubmit={addNumber} hidden={unLock || hasRsvped}>
            <Form.Group className="mb=3" id="123">
                <Form.Label htmlFor="attendNumber"></Form.Label>
                <Form.Control
                name="attendNumber"
                alias="yes"
                placeholder="Enter Event ID"
                id="attendNumber"
                type="text"
                value={id}
                onChange={(e) => setEventId(e.target.value)}
                />
            </Form.Group>
            <Form.Group>
                <Form.Label htmlFor="userMessage">Message to the event planner</Form.Label>
                <Form.Control
                as="textarea"
                name="userMessage"
                placeholder="Enter your message here"
                id="userMessage"
                type="text"
                value={userMessage}
                onChange={(e) => setUserMessage(e.target.value)}
                />
            </Form.Group>
            <h6>{spotsLeft} spots left to RSVP</h6>
            <Button variant="secondary" type="submit" id="rsvp-btn" disabled={disable}>RSVP</Button>
            </form>
            {
                hasRsvped && (
                <span hidden={invited}>
                <TestGround eventid={id} contactid={cid}/>
                </span>
                )
            }
        </div>
    </div>
    );
}

export default RsvpEvent;